export default __webpack_public_path__ + "static/media/plus-icon-dark.4721d5db.svg";